<div class="grid grid-cols-12 gap-6 p-3 mb-5 bg-gray-50">
  <div class="col-span-12 lg:col-span-6 border-l-4 border-gray-700 pl-4">
    <div class="grid">
      <p class="text-xs uppercase text-gray-500 font-medium tracking-wide">
        Social Posts Section
      </p>
      <h2 class="text-xl font-bold text-nowrap text-gray-700 leading-tight">
        Reuse
      </h2>
    </div>
  </div>
</div>

<app-social-ai-reuse-post-form></app-social-ai-reuse-post-form>
